import { useEffect, useState } from 'react';
import { getClientePrimeiroNome } from '@/features/jukebox';

interface Props {
  nome?:           string | null;
  avatarUrl?:      string | null;
  size?:           'sm' | 'md' | 'lg';
  showNome?:       boolean;
  className?:      string;
  nomeClassName?:  string;
}

const SIZE = {
  sm: {
    container: 'w-[clamp(20px,1.6vw,28px)] h-[clamp(20px,1.6vw,28px)]',
    initials:  'text-[clamp(8px,0.65vw,11px)]',
    nome:      'text-[clamp(10px,0.9vw,14px)]',
  },
  md: {
    container: 'w-[clamp(28px,2.2vw,40px)] h-[clamp(28px,2.2vw,40px)]',
    initials:  'text-[clamp(10px,0.8vw,14px)]',
    nome:      'text-[clamp(11px,1.0vw,16px)]',
  },
  lg: {
    container: 'w-[clamp(36px,3vw,52px)] h-[clamp(36px,3vw,52px)]',
    initials:  'text-[clamp(12px,1vw,18px)]',
    nome:      'text-[clamp(12px,1.1vw,18px)]',
  },
} as const;

export default function TvClienteBadge({
  nome,
  avatarUrl,
  size = 'md',
  showNome = true,
  className = '',
  nomeClassName = 'text-white font-semibold',
}: Props) {
  const primeiro = getClientePrimeiroNome(nome);
  const [avatarBroken, setAvatarBroken] = useState(false);

  useEffect(() => {
    setAvatarBroken(false);
  }, [avatarUrl]);

  if (!primeiro) return null;

  const s = SIZE[size];

  return (
    <span className={`inline-flex items-center gap-[clamp(6px,0.5vw,10px)] min-w-0 ${className}`}>
      <span
        className={`${s.container} rounded-full bg-gradient-to-br from-orange-500/25 to-rose-500/25 border border-white/20 flex items-center justify-center shrink-0 overflow-hidden ring-1 ring-white/10`}
      >
        {avatarUrl && !avatarBroken ? (
          <img
            src={avatarUrl}
            alt=""
            className="w-full h-full object-cover"
            onError={() => setAvatarBroken(true)}
          />
        ) : (
          <span className={`${s.initials} font-bold text-orange-200`}>
            {primeiro.charAt(0).toUpperCase()}
          </span>
        )}
      </span>
      {showNome && (
        <span className={`${s.nome} truncate ${nomeClassName}`}>{primeiro}</span>
      )}
    </span>
  );
}
